import CostCenterPage from '@/view/pages/dashboard-owner-gym/cost-center'
import ExercisePage from '@/view/pages/dashboard-owner-gym/exercise'
import PlansPage from '@/view/pages/dashboard-owner-gym/plans'
import UnitsPage from '@/view/pages/dashboard-owner-gym/units'
import UsersPage from '@/view/pages/dashboard-owner-gym/users'
import { createBrowserRouter } from 'react-router-dom'
import { ForgotPassword } from '../view/components/forgot-password'
import { LoginFormPage } from '../view/components/login-form'
import { CashRegister } from '../view/pages/dashboard-owner-gym/cash-register/cash-register'
import ContractPage from '../view/pages/dashboard-owner-gym/contracts/contract'
import DashboardNavigation from '../view/pages/dashboard-owner-gym/dashboard-navigation'
import DashboardsPage from '../view/pages/dashboard-owner-gym/dashboard/dashboards'
import EmployeesPage from '../view/pages/dashboard-owner-gym/employees'
import ReceptionPage from '../view/pages/dashboard-owner-gym/reception'
import { Reports } from '../view/pages/dashboard-owner-gym/reports/reports'
import { RoomsAndSessions } from '../view/pages/dashboard-owner-gym/rooms-and-sessions/rooms-and-classes'
import { ServicesAndProducts } from '../view/pages/dashboard-owner-gym/services-and-products'
import { Example } from '../view/pages/example'
import LoginPage from '../view/pages/login-page'
import { ExerciseSheet } from '../view/pages/member/exercise/exercise-sheet'
import MemberPage from '../view/pages/member/member-page'
import { RoutesPath } from './routes-path'
import { RouteProviderProtect } from './validate-auth'

export const routes = createBrowserRouter([
  {
    path: '/',
    element: <Example />
  },
  {
    path: RoutesPath.login,
    element: <LoginPage />,
    children: [
      { path: '', element: <LoginFormPage /> },
      {
        path: 'esqueci-minha-senha',
        element: <ForgotPassword />
      }
    ]
  },
  {
    path: RoutesPath.dashboard,
    element: <DashboardNavigation />,
    children: [
      {
        path: '',
        element: <RouteProviderProtect element={<DashboardsPage />} />
      },
      {
        path: RoutesPath.reception,
        element: <ReceptionPage />
      },
      {
        path: RoutesPath.students,
        element: <RouteProviderProtect element={<MemberPage />} />
      },
      {
        path: RoutesPath.finance,
        element: <>financeiro</>
      },
      {
        path: RoutesPath.reports,
        element: <Reports />
      },
      {
        path: RoutesPath.costCenter,
        element: <CostCenterPage />
      },
      {
        path: RoutesPath.gyns,
        element: <>Academia</>
      },
      {
        path: RoutesPath.units,
        element: <UnitsPage />
      },
      {
        path: RoutesPath.plans,
        element: <PlansPage />
      },
      {
        path: RoutesPath.employees,
        element: <EmployeesPage />
      },
      {
        path: RoutesPath.sales,
        element: <>vendas</>
      },
      {
        path: RoutesPath.consultant,
        element: <h1>Consultor</h1>
      },
      {
        path: RoutesPath.users,
        element: <UsersPage />
      },
      {
        path: RoutesPath.roomsAndSessions,
        element: <RoomsAndSessions />
      },
      {
        path: RoutesPath.contract,
        element: <ContractPage />
      },
      {
        path: RoutesPath.cashRegister,
        element: <CashRegister />
      },
      {
        path: RoutesPath.servicesAndProducts,
        element: <ServicesAndProducts />
      },
      {
        path: RoutesPath.excercise,
        element: <ExercisePage />
      },
      {
        path: RoutesPath.sheetExercise,
        element: <ExerciseSheet />
      }
    ]
  }
])
